export const defaultShmiraListEshbal: any = {
  sidurArchive: [
    {
      id: "Del1",
      Name: "סידור גנים",
      orders: [
        {
          id: "1",
          driverName: "חן",
          startHour: "08:00",
          finishHour: "09:00",
          TypeOfDrive: "3",
          Comments: "",
          passengers: "1",
          flexibility: ["-30", "10"],
          location: "",
        },
        {
          id: "2",
          driverName: "אבי",
          startHour: "08:00",
          finishHour: "09:00",
          TypeOfDrive: "3",
          Comments: "",
          passengers: "1",
          flexibility: ["-30", "10"],
          location: "",
        },
        {
          id: "3",
          driverName: "רוני",
          startHour: "08:00",
          finishHour: "09:00",
          TypeOfDrive: "3",
          Comments: "",
          passengers: "1",
          flexibility: ["-30", "10"],
          location: "",
        },
      ],
      deletedOrders: [],
      vehicles: [
        {
          id: "1",
          vehicleName: "סנאו",
          startHour: "08:00",
          endHour: "09:00",
          kmLimit: "",
          seats: "5",
          Comments: "",
        },
        {
          id: "2",
          vehicleName: "שלגיה",
          startHour: "08:00",
          endHour: "09:00",
          kmLimit: "",
          seats: "5",
          Comments: "",
        },
        {
          id: "3",
          vehicleName: "שכור",
          startHour: "08:00",
          endHour: "09:00",
          kmLimit: "",
          seats: "5",
          Comments: "",
        },
        {
          id: "4",
          vehicleName: "מאזדה",
          startHour: "08:00",
          endHour: "09:00",
          kmLimit: "",
          seats: "5",
          Comments: "",
        },
      ],
      sketches: [],
      chosenSketch: "",
      locationGroup: null,
      defaultOrderValues: {},
    },
  ],
  locationGroupInEdit: null,
  sidurCollection: [
    {
      id: "5",
      Name: "סידור לסקיצה",
      orders: [
        {
          id: "99",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "08:00",
          Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
          driverName: "חן פלג",
          finishHour: "13:00",
        },
        {
          id: "132",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "08:00",
          Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
          driverName: "חן פלג",
          finishHour: "13:00",
        },
        {
          id: "100",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "3",
          startHour: "07:20",
          Comments:
            "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
          driverName: "רייצ'ל",
          finishHour: "10,10",
        },
        {
          id: "101",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "12:50",
          Comments: "רייצ'ל למרפאה במשגב עד 13:00",
          driverName: "רייצ'ל",
          finishHour: "14:00",
        },
        {
          id: "102",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "3",
          startHour: "19:00",
          Comments: "",
          driverName: "רייצ'ל",
          finishHour: "",
        },
        {
          id: "103",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "2",
          startHour: "08:30",
          Comments: "סתו מבקשת צמוד עד 16:00. לדבר איתי  אם בעיה",
          driverName: "סתו",
          finishHour: "14:00",
        },
        {
          id: "104",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "09:45",
          Comments: "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
          driverName: "ורד",
          finishHour: "11:00",
        },
        {
          id: "105",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "",
          TypeOfDrive: "2",
          startHour: "13:30",
          Comments: "אלון לאיסוף שיבולי השמש עד 14:30",
          driverName: "אלון דרור",
          finishHour: "14:30",
        },
        {
          id: "106",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "2",
          TypeOfDrive: "2",
          startHour: "15:50",
          Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
          driverName: "אלון דרור",
          finishHour: "17:20",
        },
        {
          id: "107",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "16:00",
          Comments: "אלון ושקד מקופח כללית משגב אם אין צמוד",
          driverName: "אלון דרור",
          finishHour: "17:00",
        },
        {
          id: "108",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "2",
          startHour: "13:30",
          Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
          driverName: "ענבר",
          finishHour: "15:30",
        },
        {
          id: "109",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "2",
          TypeOfDrive: "2",
          startHour: "16:00",
          Comments: "רז מרקפת ",
          driverName: "ענבר",
          finishHour: "16:30",
        },
        {
          id: "110",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "08:40",
          Comments:
            "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
          driverName: "ענבר",
          finishHour: "10:30",
        },
        {
          id: "111",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "3",
          startHour: "08:15",
          Comments: "זהר לכרמיאל",
          driverName: "זהר",
          finishHour: "",
        },
        {
          id: "112",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "2",
          startHour: "14:00",
          Comments:
            "זהר בחיפה ורוצה להישאר עד מאוחר  ולחזור ברכב. אם יש נסיעה לעשות איתה חילוף מה טוב. אם לא ואפשר לשריין רכב ואנסה למצוא נהג/ת, גם טוב. ",
          driverName: "זהר",
          finishHour: "20:00",
        },
        {
          id: "113",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "",
          TypeOfDrive: "2",
          startHour: "14:00",
          Comments: "אורי כהן וטל לכנרת עד 19",
          driverName: "טל",
          finishHour: "19:00",
        },
        {
          id: "115",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "16:00",
          Comments:
            "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
          driverName: "עדי",
          finishHour: "17:30",
        },
        {
          id: "116",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "13",
          TypeOfDrive: "3",
          startHour: "08:30",
          Comments: "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
          driverName: "רינת שרון",
          finishHour: "10,10",
        },
        {
          id: "117",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "9",
          TypeOfDrive: "3",
          startHour: "09:15",
          Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
          driverName: "אוריאל",
          finishHour: "12:00",
        },
        {
          id: "118",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "9",
          TypeOfDrive: "4",
          startHour: "14:15",
          Comments:
            "אוריאל ברכב דבר ממרכז השיח בחיפה לאשבל. אם עדיף שאני אסע ברכב אחר וישאיר את רכב דבר בחיפה אז אין בעיה. הוא יכול לשמש את הסידור אחהצ וצריך להגיע ברביעי בבוקר לטבריה או רביד ",
          driverName: "אוריאל",
          finishHour: "",
        },
        {
          id: "119",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "3",
          startHour: "07:20",
          Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
          driverName: "מורן",
          finishHour: "",
        },
        {
          id: "120",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "4",
          startHour: "14:00",
          Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
          driverName: "מורן",
          finishHour: "13:00,13:00",
        },
        {
          id: "122",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "3",
          startHour: "18:30",
          Comments:
            "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
          driverName: "תמה",
          finishHour: "22:00,22:00",
        },
        {
          id: "123",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "06:15",
          Comments: "ב615  ליאור למשגב עד 815",
          driverName: "ליאור דינרמן",
          finishHour: "08:30",
        },
        {
          id: "124",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "14",
          TypeOfDrive: "2",
          startHour: "19:15",
          Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
          driverName: "ליאור דינרמן",
          finishHour: "22:30",
        },
        {
          id: "125",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "4",
          TypeOfDrive: "2",
          startHour: "14:00",
          Comments:
            "אורי עם  אחד הברלינגו להביא כלב. חוזר עד 17:00 לדבר איתי על בעיות",
          driverName: "אורי",
          finishHour: "17:00",
        },
        {
          id: "126",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "4",
          TypeOfDrive: "2",
          startHour: "08:45",
          Comments: "שירי צמוד לעכו ועפולה עד 15:15. אם בעייתי דברו איתי",
          driverName: "שירי אליאס",
          finishHour: "17:00",
        },
        {
          id: "127",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "5",
          TypeOfDrive: "3",
          startHour: "07:30",
          Comments: "עומר לתיכון ",
          driverName: "עומר כהן",
          finishHour: "",
        },
        {
          id: "128",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "5",
          TypeOfDrive: "4",
          startHour: "17:30",
          Comments:
            "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
          driverName: "עומר כהן",
          finishHour: "",
        },
        {
          id: "129",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "2",
          TypeOfDrive: "2",
          startHour: "09:00",
          Comments: "עמיר צמוד עד 15 לאזור טבריה",
          driverName: "עמיר",
          finishHour: "15:00",
        },
        {
          id: "130",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "10",
          TypeOfDrive: "3",
          startHour: "14:00",
          Comments: "14:00 אייל מאשבל ליובלים ",
          driverName: "אייל יסוד",
          finishHour: "14:00,14:00",
        },
        {
          id: "131",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "10",
          TypeOfDrive: "4",
          startHour: "16:30",
          Comments:
            "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
          driverName: "אייל יסוד",
          finishHour: "20:00,20:00",
        },
      ],
      deletedOrders: [],
      vehicles: [
        {
          id: "1",
          vehicleName: "שלגיה",
          startHour: "08:00",
          endHour: "09:00",
          kmLimit: "",
          seats: "7",
          Comments: "",
        },
        {
          id: "3",
          vehicleName: "סנואו",
          startHour: "08:00",
          endHour: "09:00",
          kmLimit: "",
          seats: "7",
          Comments: "",
        },
        {
          id: "4",
          vehicleName: "שכור",
          startHour: "08:00",
          endHour: "09:00",
          kmLimit: "",
          seats: "5",
          Comments: "",
        },
        {
          id: "5",
          vehicleName: "ברלינגו",
          startHour: "08:00",
          endHour: "09:00",
          kmLimit: "",
          seats: "5",
          Comments: "",
        },
      ],
      sketches: [
        {
          id: "1",
          name: "ראשונה",
          vehicleSchedules: [
            {
              id: "2",
              VehicleId: "1",
              drives: [
                {
                  id: "6",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "06:15",
                  Comments: "ב615  ליאור למשגב עד 815",
                  driverName: "ליאור דינרמן",
                  finishHour: "08:30",
                  implementsOrders: ["123"],
                  description: "ליאור דינרמן במשגב",
                },
                {
                  id: "7",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "08:40",
                  Comments:
                    "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
                  driverName: "ענבר",
                  finishHour: "10:30",
                  implementsOrders: ["110"],
                  description: "ענבר במשגב",
                },
                {
                  id: "8",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "12:50",
                  Comments: "רייצ'ל למרפאה במשגב עד 13:00",
                  driverName: "רייצ'ל",
                  finishHour: "14:00",
                  implementsOrders: ["101"],
                  description: "רייצ'ל במשגב",
                },
                {
                  id: "9",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "2",
                  TypeOfDrive: "2",
                  startHour: "15:50",
                  Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
                  driverName: "אלון דרור",
                  finishHour: "17:20",
                  implementsOrders: ["106"],
                  description: "אלון דרור ברקפת",
                },
                {
                  id: "10",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "1",
                  TypeOfDrive: "3",
                  startHour: "18:30",
                  Comments:
                    "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
                  driverName: "תמה",
                  finishHour: "19:30",
                  implementsOrders: ["122"],
                  description: "תמה  אל  כרמיאל",
                },
              ],
              Comments: "",
            },
            {
              id: "3",
              VehicleId: "3",
              drives: [
                {
                  id: "11",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "3",
                  TypeOfDrive: "3",
                  startHour: "07:20",
                  Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
                  driverName: "מורן",
                  finishHour: "09:00",
                  implementsOrders: ["119"],
                  description: "מורן  אל  חיפה",
                },
                {
                  id: "12",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "2",
                  TypeOfDrive: "2",
                  startHour: "09:00",
                  Comments: "עמיר צמוד עד 15 לאזור טבריה",
                  driverName: "עמיר",
                  finishHour: "15:00",
                  implementsOrders: ["129"],
                  description: "עמיר ברקפת",
                },
                {
                  id: "13",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "10",
                  TypeOfDrive: "4",
                  startHour: "16:00",
                  Comments:
                    "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
                  driverName: "אייל יסוד",
                  finishHour: "17:00",
                  implementsOrders: ["131"],
                  description: "אייל יסוד מיובלים",
                },
                {
                  id: "14",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "3",
                  startHour: "19:00",
                  Comments: "",
                  driverName: "רייצ'ל",
                  finishHour: "20:00",
                  implementsOrders: ["102"],
                  description: "רייצ'ל  אל  משגב",
                },
              ],
              Comments: "",
            },
            {
              id: "4",
              VehicleId: "4",
              drives: [
                {
                  id: "15",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "1",
                  TypeOfDrive: "3",
                  startHour: "07:20",
                  Comments:
                    "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
                  driverName: "רייצ'ל",
                  finishHour: "08:20",
                  implementsOrders: ["100"],
                  description: "רייצ'ל  אל  כרמיאל",
                },
                {
                  id: "16",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "13",
                  TypeOfDrive: "3",
                  startHour: "08:30",
                  Comments:
                    "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
                  driverName: "רינת שרון",
                  finishHour: "09:20",
                  implementsOrders: ["116"],
                  description: "רינת שרון  אל  רכבת כרמיאל",
                },
                {
                  id: "17",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "09:45",
                  Comments:
                    "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
                  driverName: "ורד",
                  finishHour: "11:00",
                  implementsOrders: ["104"],
                  description: "ורד במשגב",
                },
                {
                  id: "18",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "3",
                  TypeOfDrive: "4",
                  startHour: "13:10",
                  Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
                  driverName: "מורן",
                  finishHour: "14:50",
                  implementsOrders: ["120"],
                  description: "מורן מחיפה",
                },
                {
                  id: "19",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "16:00",
                  Comments:
                    "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
                  driverName: "עדי",
                  finishHour: "17:30",
                  implementsOrders: ["115"],
                  description: "עדי במשגב",
                },
                {
                  id: "20",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "14",
                  TypeOfDrive: "2",
                  startHour: "19:15",
                  Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
                  driverName: "ליאור דינרמן",
                  finishHour: "22:30",
                  implementsOrders: ["124"],
                  description: "ליאור דינרמן באחר",
                },
              ],
              Comments: "",
            },
            {
              id: "5",
              VehicleId: "5",
              drives: [
                {
                  id: "21",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "5",
                  TypeOfDrive: "3",
                  startHour: "07:30",
                  Comments: "עומר לתיכון ",
                  driverName: "עומר כהן",
                  finishHour: "09:10",
                  implementsOrders: ["127"],
                  description: "עומר כהן  אל  חברתי",
                },
                {
                  id: "22",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "9",
                  TypeOfDrive: "3",
                  startHour: "09:15",
                  Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
                  driverName: "אוריאל",
                  finishHour: "10:15",
                  implementsOrders: ["117"],
                  description: "אוריאל  אל  מרכז",
                },
                {
                  id: "23",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "1",
                  TypeOfDrive: "2",
                  startHour: "13:30",
                  Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
                  driverName: "ענבר",
                  finishHour: "15:30",
                  implementsOrders: ["108"],
                  description: "ענבר בכרמיאל",
                },
                {
                  id: "24",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "2",
                  TypeOfDrive: "2",
                  startHour: "16:00",
                  Comments: "רז מרקפת ",
                  driverName: "ענבר",
                  finishHour: "16:30",
                  implementsOrders: ["109"],
                  description: "ענבר ברקפת",
                },
                {
                  id: "25",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "5",
                  TypeOfDrive: "4",
                  startHour: "16:40",
                  Comments:
                    "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
                  driverName: "עומר כהן",
                  finishHour: "18:20",
                  implementsOrders: ["128"],
                  description: "עומר כהן מחברתי",
                },
              ],
              Comments: "",
            },
          ],
          Comments: "",
          unassignedOrders: [
            {
              id: "99",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "08:00",
              Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
              driverName: "חן פלג",
              finishHour: "13:00",
            },
            {
              id: "103",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "2",
              startHour: "08:30",
              Comments: "סתו מבקשת צמוד עד 16:00. לדבר איתי  אם בעיה",
              driverName: "סתו",
              finishHour: "14:00",
            },
            {
              id: "105",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "",
              TypeOfDrive: "2",
              startHour: "13:30",
              Comments: "אלון לאיסוף שיבולי השמש עד 14:30",
              driverName: "אלון דרור",
              finishHour: "14:30",
            },
            {
              id: "107",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments: "אלון ושקד מקופח כללית משגב אם אין צמוד",
              driverName: "אלון דרור",
              finishHour: "17:00",
            },
            {
              id: "111",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "08:15",
              Comments: "זהר לכרמיאל",
              driverName: "זהר",
              finishHour: "",
            },
            {
              id: "112",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "2",
              startHour: "14:00",
              Comments:
                "זהר בחיפה ורוצה להישאר עד מאוחר  ולחזור ברכב. אם יש נסיעה לעשות איתה חילוף מה טוב. אם לא ואפשר לשריין רכב ואנסה למצוא נהג/ת, גם טוב. ",
              driverName: "זהר",
              finishHour: "20:00",
            },
            {
              id: "113",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "",
              TypeOfDrive: "2",
              startHour: "14:00",
              Comments: "אורי כהן וטל לכנרת עד 19",
              driverName: "טל",
              finishHour: "19:00",
            },
            {
              id: "118",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "9",
              TypeOfDrive: "4",
              startHour: "14:15",
              Comments:
                "אוריאל ברכב דבר ממרכז השיח בחיפה לאשבל. אם עדיף שאני אסע ברכב אחר וישאיר את רכב דבר בחיפה אז אין בעיה. הוא יכול לשמש את הסידור אחהצ וצריך להגיע ברביעי בבוקר לטבריה או רביד ",
              driverName: "אוריאל",
              finishHour: "",
            },
            {
              id: "125",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "4",
              TypeOfDrive: "2",
              startHour: "14:00",
              Comments:
                "אורי עם  אחד הברלינגו להביא כלב. חוזר עד 17:00 לדבר איתי על בעיות",
              driverName: "אורי",
              finishHour: "17:00",
            },
            {
              id: "126",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "4",
              TypeOfDrive: "2",
              startHour: "08:45",
              Comments: "שירי צמוד לעכו ועפולה עד 15:15. אם בעייתי דברו איתי",
              driverName: "שירי אליאס",
              finishHour: "17:00",
            },
            {
              id: "130",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "10",
              TypeOfDrive: "3",
              startHour: "14:00",
              Comments: "14:00 אייל מאשבל ליובלים ",
              driverName: "אייל יסוד",
              finishHour: "14:00,14:00",
            },
          ],
          assignedOrders: [
            {
              id: "100",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "07:20",
              Comments:
                "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
              driverName: "רייצ'ל",
              finishHour: "10,10",
            },
            {
              id: "101",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "12:50",
              Comments: "רייצ'ל למרפאה במשגב עד 13:00",
              driverName: "רייצ'ל",
              finishHour: "14:00",
            },
            {
              id: "102",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "3",
              startHour: "19:00",
              Comments: "",
              driverName: "רייצ'ל",
              finishHour: "",
            },
            {
              id: "104",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "09:45",
              Comments:
                "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
              driverName: "ורד",
              finishHour: "11:00",
            },
            {
              id: "106",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "15:50",
              Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
              driverName: "אלון דרור",
              finishHour: "17:20",
            },
            {
              id: "108",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "2",
              startHour: "13:30",
              Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
              driverName: "ענבר",
              finishHour: "15:30",
            },
            {
              id: "109",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments: "רז מרקפת ",
              driverName: "ענבר",
              finishHour: "16:30",
            },
            {
              id: "110",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "08:40",
              Comments:
                "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
              driverName: "ענבר",
              finishHour: "10:30",
            },
            {
              id: "115",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments:
                "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
              driverName: "עדי",
              finishHour: "17:30",
            },
            {
              id: "116",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "13",
              TypeOfDrive: "3",
              startHour: "08:30",
              Comments: "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
              driverName: "רינת שרון",
              finishHour: "10,10",
            },
            {
              id: "117",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "9",
              TypeOfDrive: "3",
              startHour: "09:15",
              Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
              driverName: "אוריאל",
              finishHour: "12:00",
            },
            {
              id: "119",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "3",
              startHour: "07:20",
              Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
              driverName: "מורן",
              finishHour: "",
            },
            {
              id: "120",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "4",
              startHour: "14:00",
              Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
              driverName: "מורן",
              finishHour: "13:00,13:00",
            },
            {
              id: "122",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "18:30",
              Comments:
                "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
              driverName: "תמה",
              finishHour: "22:00,22:00",
            },
            {
              id: "123",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "06:15",
              Comments: "ב615  ליאור למשגב עד 815",
              driverName: "ליאור דינרמן",
              finishHour: "08:30",
            },
            {
              id: "124",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "14",
              TypeOfDrive: "2",
              startHour: "19:15",
              Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
              driverName: "ליאור דינרמן",
              finishHour: "22:30",
            },
            {
              id: "127",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "5",
              TypeOfDrive: "3",
              startHour: "07:30",
              Comments: "עומר לתיכון ",
              driverName: "עומר כהן",
              finishHour: "",
            },
            {
              id: "128",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "5",
              TypeOfDrive: "4",
              startHour: "17:30",
              Comments:
                "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
              driverName: "עומר כהן",
              finishHour: "",
            },
            {
              id: "129",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "09:00",
              Comments: "עמיר צמוד עד 15 לאזור טבריה",
              driverName: "עמיר",
              finishHour: "15:00",
            },
            {
              id: "131",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "10",
              TypeOfDrive: "4",
              startHour: "16:30",
              Comments:
                "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
              driverName: "אייל יסוד",
              finishHour: "20:00,20:00",
            },
          ],
        },
        {
          id: "2",
          name: "שנייה",
          vehicleSchedules: [
            {
              id: "2",
              VehicleId: "1",
              drives: [
                {
                  id: "6",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "06:15",
                  Comments: "ב615  ליאור למשגב עד 815",
                  driverName: "ליאור דינרמן",
                  finishHour: "08:30",
                  implementsOrders: ["123"],
                  description: "ליאור דינרמן במשגב",
                },
                {
                  id: "7",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "08:40",
                  Comments:
                    "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
                  driverName: "ענבר",
                  finishHour: "10:30",
                  implementsOrders: ["110"],
                  description: "ענבר במשגב",
                },
                {
                  id: "8",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "12:50",
                  Comments: "רייצ'ל למרפאה במשגב עד 13:00",
                  driverName: "רייצ'ל",
                  finishHour: "14:00",
                  implementsOrders: ["101"],
                  description: "רייצ'ל במשגב",
                },
                {
                  id: "9",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "2",
                  TypeOfDrive: "2",
                  startHour: "15:50",
                  Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
                  driverName: "אלון דרור",
                  finishHour: "17:20",
                  implementsOrders: ["106"],
                  description: "אלון דרור ברקפת",
                },
                {
                  id: "10",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "1",
                  TypeOfDrive: "3",
                  startHour: "18:30",
                  Comments:
                    "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
                  driverName: "תמה",
                  finishHour: "19:30",
                  implementsOrders: ["122"],
                  description: "תמה  אל  כרמיאל",
                },
              ],
              Comments: "",
            },
            {
              id: "3",
              VehicleId: "3",
              drives: [
                {
                  id: "11",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "3",
                  TypeOfDrive: "3",
                  startHour: "07:20",
                  Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
                  driverName: "מורן",
                  finishHour: "09:00",
                  implementsOrders: ["119"],
                  description: "מורן  אל  חיפה",
                },
                {
                  id: "12",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "2",
                  TypeOfDrive: "2",
                  startHour: "09:00",
                  Comments: "עמיר צמוד עד 15 לאזור טבריה",
                  driverName: "עמיר",
                  finishHour: "15:00",
                  implementsOrders: ["129"],
                  description: "עמיר ברקפת",
                },
                {
                  id: "13",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "10",
                  TypeOfDrive: "4",
                  startHour: "16:00",
                  Comments:
                    "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
                  driverName: "אייל יסוד",
                  finishHour: "17:00",
                  implementsOrders: ["131"],
                  description: "אייל יסוד מיובלים",
                },
                {
                  id: "14",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "3",
                  startHour: "19:00",
                  Comments: "",
                  driverName: "רייצ'ל",
                  finishHour: "20:00",
                  implementsOrders: ["102"],
                  description: "רייצ'ל  אל  משגב",
                },
              ],
              Comments: "",
            },
            {
              id: "4",
              VehicleId: "4",
              drives: [
                {
                  id: "15",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "1",
                  TypeOfDrive: "3",
                  startHour: "07:20",
                  Comments:
                    "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
                  driverName: "רייצ'ל",
                  finishHour: "08:20",
                  implementsOrders: ["100"],
                  description: "רייצ'ל  אל  כרמיאל",
                },
                {
                  id: "16",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "13",
                  TypeOfDrive: "3",
                  startHour: "08:30",
                  Comments:
                    "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
                  driverName: "רינת שרון",
                  finishHour: "09:20",
                  implementsOrders: ["116"],
                  description: "רינת שרון  אל  רכבת כרמיאל",
                },
                {
                  id: "17",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "09:45",
                  Comments:
                    "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
                  driverName: "ורד",
                  finishHour: "11:00",
                  implementsOrders: ["104"],
                  description: "ורד במשגב",
                },
                {
                  id: "18",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "3",
                  TypeOfDrive: "4",
                  startHour: "13:10",
                  Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
                  driverName: "מורן",
                  finishHour: "14:50",
                  implementsOrders: ["120"],
                  description: "מורן מחיפה",
                },
                {
                  id: "19",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "6",
                  TypeOfDrive: "2",
                  startHour: "16:00",
                  Comments:
                    "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
                  driverName: "עדי",
                  finishHour: "17:30",
                  implementsOrders: ["115"],
                  description: "עדי במשגב",
                },
                {
                  id: "20",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "14",
                  TypeOfDrive: "2",
                  startHour: "19:15",
                  Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
                  driverName: "ליאור דינרמן",
                  finishHour: "22:30",
                  implementsOrders: ["124"],
                  description: "ליאור דינרמן באחר",
                },
              ],
              Comments: "",
            },
            {
              id: "5",
              VehicleId: "5",
              drives: [
                {
                  id: "21",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "5",
                  TypeOfDrive: "3",
                  startHour: "07:30",
                  Comments: "עומר לתיכון ",
                  driverName: "עומר כהן",
                  finishHour: "09:10",
                  implementsOrders: ["127"],
                  description: "עומר כהן  אל  חברתי",
                },
                {
                  id: "22",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "9",
                  TypeOfDrive: "3",
                  startHour: "09:15",
                  Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
                  driverName: "אוריאל",
                  finishHour: "10:15",
                  implementsOrders: ["117"],
                  description: "אוריאל  אל  מרכז",
                },
                {
                  id: "23",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "1",
                  TypeOfDrive: "2",
                  startHour: "13:30",
                  Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
                  driverName: "ענבר",
                  finishHour: "15:30",
                  implementsOrders: ["108"],
                  description: "ענבר בכרמיאל",
                },
                {
                  id: "24",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "2",
                  TypeOfDrive: "2",
                  startHour: "16:00",
                  Comments: "רז מרקפת ",
                  driverName: "ענבר",
                  finishHour: "16:30",
                  implementsOrders: ["109"],
                  description: "ענבר ברקפת",
                },
                {
                  id: "25",
                  flexibility: ["-30", "10"],
                  passengers: "1",
                  location: "5",
                  TypeOfDrive: "4",
                  startHour: "16:40",
                  Comments:
                    "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
                  driverName: "עומר כהן",
                  finishHour: "18:20",
                  implementsOrders: ["128"],
                  description: "עומר כהן מחברתי",
                },
              ],
              Comments: "",
            },
          ],
          Comments: "",
          unassignedOrders: [
            {
              id: "99",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "08:00",
              Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
              driverName: "חן פלג",
              finishHour: "13:00",
            },
            {
              id: "132",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "08:00",
              Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
              driverName: "חן פלג",
              finishHour: "13:00",
            },
            {
              id: "103",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "2",
              startHour: "08:30",
              Comments: "סתו מבקשת צמוד עד 16:00. לדבר איתי  אם בעיה",
              driverName: "סתו",
              finishHour: "14:00",
            },
            {
              id: "105",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "",
              TypeOfDrive: "2",
              startHour: "13:30",
              Comments: "אלון לאיסוף שיבולי השמש עד 14:30",
              driverName: "אלון דרור",
              finishHour: "14:30",
            },
            {
              id: "107",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments: "אלון ושקד מקופח כללית משגב אם אין צמוד",
              driverName: "אלון דרור",
              finishHour: "17:00",
            },
            {
              id: "111",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "08:15",
              Comments: "זהר לכרמיאל",
              driverName: "זהר",
              finishHour: "",
            },
            {
              id: "112",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "2",
              startHour: "14:00",
              Comments:
                "זהר בחיפה ורוצה להישאר עד מאוחר  ולחזור ברכב. אם יש נסיעה לעשות איתה חילוף מה טוב. אם לא ואפשר לשריין רכב ואנסה למצוא נהג/ת, גם טוב. ",
              driverName: "זהר",
              finishHour: "20:00",
            },
            {
              id: "113",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "",
              TypeOfDrive: "2",
              startHour: "14:00",
              Comments: "אורי כהן וטל לכנרת עד 19",
              driverName: "טל",
              finishHour: "19:00",
            },
            {
              id: "118",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "9",
              TypeOfDrive: "4",
              startHour: "14:15",
              Comments:
                "אוריאל ברכב דבר ממרכז השיח בחיפה לאשבל. אם עדיף שאני אסע ברכב אחר וישאיר את רכב דבר בחיפה אז אין בעיה. הוא יכול לשמש את הסידור אחהצ וצריך להגיע ברביעי בבוקר לטבריה או רביד ",
              driverName: "אוריאל",
              finishHour: "",
            },
            {
              id: "125",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "4",
              TypeOfDrive: "2",
              startHour: "14:00",
              Comments:
                "אורי עם  אחד הברלינגו להביא כלב. חוזר עד 17:00 לדבר איתי על בעיות",
              driverName: "אורי",
              finishHour: "17:00",
            },
            {
              id: "126",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "4",
              TypeOfDrive: "2",
              startHour: "08:45",
              Comments: "שירי צמוד לעכו ועפולה עד 15:15. אם בעייתי דברו איתי",
              driverName: "שירי אליאס",
              finishHour: "17:00",
            },
            {
              id: "130",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "10",
              TypeOfDrive: "3",
              startHour: "14:00",
              Comments: "14:00 אייל מאשבל ליובלים ",
              driverName: "אייל יסוד",
              finishHour: "14:00,14:00",
            },
          ],
          assignedOrders: [
            {
              id: "100",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "07:20",
              Comments:
                "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
              driverName: "רייצ'ל",
              finishHour: "10,10",
            },
            {
              id: "101",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "12:50",
              Comments: "רייצ'ל למרפאה במשגב עד 13:00",
              driverName: "רייצ'ל",
              finishHour: "14:00",
            },
            {
              id: "102",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "3",
              startHour: "19:00",
              Comments: "",
              driverName: "רייצ'ל",
              finishHour: "",
            },
            {
              id: "104",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "09:45",
              Comments:
                "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
              driverName: "ורד",
              finishHour: "11:00",
            },
            {
              id: "106",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "15:50",
              Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
              driverName: "אלון דרור",
              finishHour: "17:20",
            },
            {
              id: "108",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "2",
              startHour: "13:30",
              Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
              driverName: "ענבר",
              finishHour: "15:30",
            },
            {
              id: "109",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments: "רז מרקפת ",
              driverName: "ענבר",
              finishHour: "16:30",
            },
            {
              id: "110",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "08:40",
              Comments:
                "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
              driverName: "ענבר",
              finishHour: "10:30",
            },
            {
              id: "115",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments:
                "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
              driverName: "עדי",
              finishHour: "17:30",
            },
            {
              id: "116",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "13",
              TypeOfDrive: "3",
              startHour: "08:30",
              Comments: "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
              driverName: "רינת שרון",
              finishHour: "10,10",
            },
            {
              id: "117",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "9",
              TypeOfDrive: "3",
              startHour: "09:15",
              Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
              driverName: "אוריאל",
              finishHour: "12:00",
            },
            {
              id: "119",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "3",
              startHour: "07:20",
              Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
              driverName: "מורן",
              finishHour: "",
            },
            {
              id: "120",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "4",
              startHour: "14:00",
              Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
              driverName: "מורן",
              finishHour: "13:00,13:00",
            },
            {
              id: "122",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "18:30",
              Comments:
                "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
              driverName: "תמה",
              finishHour: "22:00,22:00",
            },
            {
              id: "123",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "06:15",
              Comments: "ב615  ליאור למשגב עד 815",
              driverName: "ליאור דינרמן",
              finishHour: "08:30",
            },
            {
              id: "124",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "14",
              TypeOfDrive: "2",
              startHour: "19:15",
              Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
              driverName: "ליאור דינרמן",
              finishHour: "22:30",
            },
            {
              id: "127",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "5",
              TypeOfDrive: "3",
              startHour: "07:30",
              Comments: "עומר לתיכון ",
              driverName: "עומר כהן",
              finishHour: "",
            },
            {
              id: "128",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "5",
              TypeOfDrive: "4",
              startHour: "17:30",
              Comments:
                "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
              driverName: "עומר כהן",
              finishHour: "",
            },
            {
              id: "129",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "09:00",
              Comments: "עמיר צמוד עד 15 לאזור טבריה",
              driverName: "עמיר",
              finishHour: "15:00",
            },
            {
              id: "131",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "10",
              TypeOfDrive: "4",
              startHour: "16:30",
              Comments:
                "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
              driverName: "אייל יסוד",
              finishHour: "20:00,20:00",
            },
          ],
        },
      ],
      chosenSketch: "2",
      defaultOrderValues: {},
    },
  ],
  sidurId: "5",
  orders: [
    {
      id: "99",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "6",
      TypeOfDrive: "2",
      startHour: "08:00",
      Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
      driverName: "חן פלג",
      finishHour: "13:00",
    },
    {
      id: "132",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "6",
      TypeOfDrive: "2",
      startHour: "08:00",
      Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
      driverName: "חן פלג",
      finishHour: "13:00",
    },
    {
      id: "100",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "1",
      TypeOfDrive: "3",
      startHour: "07:20",
      Comments:
        "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
      driverName: "רייצ'ל",
      finishHour: "10,10",
    },
    {
      id: "101",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "6",
      TypeOfDrive: "2",
      startHour: "12:50",
      Comments: "רייצ'ל למרפאה במשגב עד 13:00",
      driverName: "רייצ'ל",
      finishHour: "14:00",
    },
    {
      id: "102",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "6",
      TypeOfDrive: "3",
      startHour: "19:00",
      Comments: "",
      driverName: "רייצ'ל",
      finishHour: "",
    },
    {
      id: "103",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "3",
      TypeOfDrive: "2",
      startHour: "08:30",
      Comments: "סתו מבקשת צמוד עד 16:00. לדבר איתי  אם בעיה",
      driverName: "סתו",
      finishHour: "14:00",
    },
    {
      id: "104",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "6",
      TypeOfDrive: "2",
      startHour: "09:45",
      Comments: "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
      driverName: "ורד",
      finishHour: "11:00",
    },
    {
      id: "105",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "",
      TypeOfDrive: "2",
      startHour: "13:30",
      Comments: "אלון לאיסוף שיבולי השמש עד 14:30",
      driverName: "אלון דרור",
      finishHour: "14:30",
    },
    {
      id: "106",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "2",
      TypeOfDrive: "2",
      startHour: "15:50",
      Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
      driverName: "אלון דרור",
      finishHour: "17:20",
    },
    {
      id: "107",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "6",
      TypeOfDrive: "2",
      startHour: "16:00",
      Comments: "אלון ושקד מקופח כללית משגב אם אין צמוד",
      driverName: "אלון דרור",
      finishHour: "17:00",
    },
    {
      id: "108",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "1",
      TypeOfDrive: "2",
      startHour: "13:30",
      Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
      driverName: "ענבר",
      finishHour: "15:30",
    },
    {
      id: "109",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "2",
      TypeOfDrive: "2",
      startHour: "16:00",
      Comments: "רז מרקפת ",
      driverName: "ענבר",
      finishHour: "16:30",
    },
    {
      id: "110",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "6",
      TypeOfDrive: "2",
      startHour: "08:40",
      Comments:
        "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
      driverName: "ענבר",
      finishHour: "10:30",
    },
    {
      id: "111",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "1",
      TypeOfDrive: "3",
      startHour: "08:15",
      Comments: "זהר לכרמיאל",
      driverName: "זהר",
      finishHour: "",
    },
    {
      id: "112",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "3",
      TypeOfDrive: "2",
      startHour: "14:00",
      Comments:
        "זהר בחיפה ורוצה להישאר עד מאוחר  ולחזור ברכב. אם יש נסיעה לעשות איתה חילוף מה טוב. אם לא ואפשר לשריין רכב ואנסה למצוא נהג/ת, גם טוב. ",
      driverName: "זהר",
      finishHour: "20:00",
    },
    {
      id: "113",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "",
      TypeOfDrive: "2",
      startHour: "14:00",
      Comments: "אורי כהן וטל לכנרת עד 19",
      driverName: "טל",
      finishHour: "19:00",
    },
    {
      id: "115",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "6",
      TypeOfDrive: "2",
      startHour: "16:00",
      Comments:
        "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
      driverName: "עדי",
      finishHour: "17:30",
    },
    {
      id: "116",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "13",
      TypeOfDrive: "3",
      startHour: "08:30",
      Comments: "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
      driverName: "רינת שרון",
      finishHour: "10,10",
    },
    {
      id: "117",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "9",
      TypeOfDrive: "3",
      startHour: "09:15",
      Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
      driverName: "אוריאל",
      finishHour: "12:00",
    },
    {
      id: "118",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "9",
      TypeOfDrive: "4",
      startHour: "14:15",
      Comments:
        "אוריאל ברכב דבר ממרכז השיח בחיפה לאשבל. אם עדיף שאני אסע ברכב אחר וישאיר את רכב דבר בחיפה אז אין בעיה. הוא יכול לשמש את הסידור אחהצ וצריך להגיע ברביעי בבוקר לטבריה או רביד ",
      driverName: "אוריאל",
      finishHour: "",
    },
    {
      id: "119",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "3",
      TypeOfDrive: "3",
      startHour: "07:20",
      Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
      driverName: "מורן",
      finishHour: "",
    },
    {
      id: "120",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "3",
      TypeOfDrive: "4",
      startHour: "14:00",
      Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
      driverName: "מורן",
      finishHour: "13:00,13:00",
    },
    {
      id: "122",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "1",
      TypeOfDrive: "3",
      startHour: "18:30",
      Comments:
        "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
      driverName: "תמה",
      finishHour: "22:00,22:00",
    },
    {
      id: "123",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "6",
      TypeOfDrive: "2",
      startHour: "06:15",
      Comments: "ב615  ליאור למשגב עד 815",
      driverName: "ליאור דינרמן",
      finishHour: "08:30",
    },
    {
      id: "124",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "14",
      TypeOfDrive: "2",
      startHour: "19:15",
      Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
      driverName: "ליאור דינרמן",
      finishHour: "22:30",
    },
    {
      id: "125",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "4",
      TypeOfDrive: "2",
      startHour: "14:00",
      Comments:
        "אורי עם  אחד הברלינגו להביא כלב. חוזר עד 17:00 לדבר איתי על בעיות",
      driverName: "אורי",
      finishHour: "17:00",
    },
    {
      id: "126",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "4",
      TypeOfDrive: "2",
      startHour: "08:45",
      Comments: "שירי צמוד לעכו ועפולה עד 15:15. אם בעייתי דברו איתי",
      driverName: "שירי אליאס",
      finishHour: "17:00",
    },
    {
      id: "127",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "5",
      TypeOfDrive: "3",
      startHour: "07:30",
      Comments: "עומר לתיכון ",
      driverName: "עומר כהן",
      finishHour: "",
    },
    {
      id: "128",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "5",
      TypeOfDrive: "4",
      startHour: "17:30",
      Comments:
        "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
      driverName: "עומר כהן",
      finishHour: "",
    },
    {
      id: "129",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "2",
      TypeOfDrive: "2",
      startHour: "09:00",
      Comments: "עמיר צמוד עד 15 לאזור טבריה",
      driverName: "עמיר",
      finishHour: "15:00",
    },
    {
      id: "130",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "10",
      TypeOfDrive: "3",
      startHour: "14:00",
      Comments: "14:00 אייל מאשבל ליובלים ",
      driverName: "אייל יסוד",
      finishHour: "14:00,14:00",
    },
    {
      id: "131",
      flexibility: ["-30", "10"],
      passengers: "1",
      location: "10",
      TypeOfDrive: "4",
      startHour: "16:30",
      Comments:
        "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
      driverName: "אייל יסוד",
      finishHour: "20:00,20:00",
    },
  ],
  vehicles: [
    {
      id: "1",
      vehicleName: "שלגיה",
      startHour: "08:00",
      endHour: "09:00",
      kmLimit: "",
      seats: "7",
      Comments: "",
    },
    {
      id: "3",
      vehicleName: "סנואו",
      startHour: "08:00",
      endHour: "09:00",
      kmLimit: "",
      seats: "7",
      Comments: "",
    },
    {
      id: "4",
      vehicleName: "שכור",
      startHour: "08:00",
      endHour: "09:00",
      kmLimit: "",
      seats: "5",
      Comments: "",
    },
    {
      id: "5",
      vehicleName: "ברלינגו",
      startHour: "08:00",
      endHour: "09:00",
      kmLimit: "",
      seats: "5",
      Comments: "",
    },
  ],
  orderIdInEdit: null,
  dataHolderForCurrentOrderInEdit: null,
  deletedOrders: [],
  defaultOrderValues: {
    id: "1",
    driverName: "",
    startHour: "08:00",
    finishHour: "09:00",
    TypeOfDrive: "3",
    Comments: "",
    passengers: "1",
    flexibility: ["-30", "10"],
    location: "",
  },
  sketches: [
    {
      id: "1",
      name: "ראשונה",
      vehicleSchedules: [
        {
          id: "2",
          VehicleId: "1",
          drives: [
            {
              id: "6",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "06:15",
              Comments: "ב615  ליאור למשגב עד 815",
              driverName: "ליאור דינרמן",
              finishHour: "08:30",
              implementsOrders: ["123"],
              description: "ליאור דינרמן במשגב",
            },
            {
              id: "7",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "08:40",
              Comments:
                "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
              driverName: "ענבר",
              finishHour: "10:30",
              implementsOrders: ["110"],
              description: "ענבר במשגב",
            },
            {
              id: "8",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "12:50",
              Comments: "רייצ'ל למרפאה במשגב עד 13:00",
              driverName: "רייצ'ל",
              finishHour: "14:00",
              implementsOrders: ["101"],
              description: "רייצ'ל במשגב",
            },
            {
              id: "9",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "15:50",
              Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
              driverName: "אלון דרור",
              finishHour: "17:20",
              implementsOrders: ["106"],
              description: "אלון דרור ברקפת",
            },
            {
              id: "10",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "18:30",
              Comments:
                "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
              driverName: "תמה",
              finishHour: "19:30",
              implementsOrders: ["122"],
              description: "תמה  אל  כרמיאל",
            },
          ],
          Comments: "",
        },
        {
          id: "3",
          VehicleId: "3",
          drives: [
            {
              id: "11",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "3",
              startHour: "07:20",
              Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
              driverName: "מורן",
              finishHour: "09:00",
              implementsOrders: ["119"],
              description: "מורן  אל  חיפה",
            },
            {
              id: "12",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "09:00",
              Comments: "עמיר צמוד עד 15 לאזור טבריה",
              driverName: "עמיר",
              finishHour: "15:00",
              implementsOrders: ["129"],
              description: "עמיר ברקפת",
            },
            {
              id: "13",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "10",
              TypeOfDrive: "4",
              startHour: "16:00",
              Comments:
                "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
              driverName: "אייל יסוד",
              finishHour: "17:00",
              implementsOrders: ["131"],
              description: "אייל יסוד מיובלים",
            },
            {
              id: "14",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "3",
              startHour: "19:00",
              Comments: "",
              driverName: "רייצ'ל",
              finishHour: "20:00",
              implementsOrders: ["102"],
              description: "רייצ'ל  אל  משגב",
            },
          ],
          Comments: "",
        },
        {
          id: "4",
          VehicleId: "4",
          drives: [
            {
              id: "15",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "07:20",
              Comments:
                "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
              driverName: "רייצ'ל",
              finishHour: "08:20",
              implementsOrders: ["100"],
              description: "רייצ'ל  אל  כרמיאל",
            },
            {
              id: "16",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "13",
              TypeOfDrive: "3",
              startHour: "08:30",
              Comments: "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
              driverName: "רינת שרון",
              finishHour: "09:20",
              implementsOrders: ["116"],
              description: "רינת שרון  אל  רכבת כרמיאל",
            },
            {
              id: "17",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "09:45",
              Comments:
                "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
              driverName: "ורד",
              finishHour: "11:00",
              implementsOrders: ["104"],
              description: "ורד במשגב",
            },
            {
              id: "18",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "4",
              startHour: "13:10",
              Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
              driverName: "מורן",
              finishHour: "14:50",
              implementsOrders: ["120"],
              description: "מורן מחיפה",
            },
            {
              id: "19",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments:
                "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
              driverName: "עדי",
              finishHour: "17:30",
              implementsOrders: ["115"],
              description: "עדי במשגב",
            },
            {
              id: "20",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "14",
              TypeOfDrive: "2",
              startHour: "19:15",
              Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
              driverName: "ליאור דינרמן",
              finishHour: "22:30",
              implementsOrders: ["124"],
              description: "ליאור דינרמן באחר",
            },
          ],
          Comments: "",
        },
        {
          id: "5",
          VehicleId: "5",
          drives: [
            {
              id: "21",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "5",
              TypeOfDrive: "3",
              startHour: "07:30",
              Comments: "עומר לתיכון ",
              driverName: "עומר כהן",
              finishHour: "09:10",
              implementsOrders: ["127"],
              description: "עומר כהן  אל  חברתי",
            },
            {
              id: "22",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "9",
              TypeOfDrive: "3",
              startHour: "09:15",
              Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
              driverName: "אוריאל",
              finishHour: "10:15",
              implementsOrders: ["117"],
              description: "אוריאל  אל  מרכז",
            },
            {
              id: "23",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "2",
              startHour: "13:30",
              Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
              driverName: "ענבר",
              finishHour: "15:30",
              implementsOrders: ["108"],
              description: "ענבר בכרמיאל",
            },
            {
              id: "24",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments: "רז מרקפת ",
              driverName: "ענבר",
              finishHour: "16:30",
              implementsOrders: ["109"],
              description: "ענבר ברקפת",
            },
            {
              id: "25",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "5",
              TypeOfDrive: "4",
              startHour: "16:40",
              Comments:
                "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
              driverName: "עומר כהן",
              finishHour: "18:20",
              implementsOrders: ["128"],
              description: "עומר כהן מחברתי",
            },
          ],
          Comments: "",
        },
      ],
      Comments: "",
      unassignedOrders: [
        {
          id: "99",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "08:00",
          Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
          driverName: "חן פלג",
          finishHour: "13:00",
        },
        {
          id: "103",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "2",
          startHour: "08:30",
          Comments: "סתו מבקשת צמוד עד 16:00. לדבר איתי  אם בעיה",
          driverName: "סתו",
          finishHour: "14:00",
        },
        {
          id: "105",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "",
          TypeOfDrive: "2",
          startHour: "13:30",
          Comments: "אלון לאיסוף שיבולי השמש עד 14:30",
          driverName: "אלון דרור",
          finishHour: "14:30",
        },
        {
          id: "107",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "16:00",
          Comments: "אלון ושקד מקופח כללית משגב אם אין צמוד",
          driverName: "אלון דרור",
          finishHour: "17:00",
        },
        {
          id: "111",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "3",
          startHour: "08:15",
          Comments: "זהר לכרמיאל",
          driverName: "זהר",
          finishHour: "",
        },
        {
          id: "112",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "2",
          startHour: "14:00",
          Comments:
            "זהר בחיפה ורוצה להישאר עד מאוחר  ולחזור ברכב. אם יש נסיעה לעשות איתה חילוף מה טוב. אם לא ואפשר לשריין רכב ואנסה למצוא נהג/ת, גם טוב. ",
          driverName: "זהר",
          finishHour: "20:00",
        },
        {
          id: "113",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "",
          TypeOfDrive: "2",
          startHour: "14:00",
          Comments: "אורי כהן וטל לכנרת עד 19",
          driverName: "טל",
          finishHour: "19:00",
        },
        {
          id: "118",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "9",
          TypeOfDrive: "4",
          startHour: "14:15",
          Comments:
            "אוריאל ברכב דבר ממרכז השיח בחיפה לאשבל. אם עדיף שאני אסע ברכב אחר וישאיר את רכב דבר בחיפה אז אין בעיה. הוא יכול לשמש את הסידור אחהצ וצריך להגיע ברביעי בבוקר לטבריה או רביד ",
          driverName: "אוריאל",
          finishHour: "",
        },
        {
          id: "125",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "4",
          TypeOfDrive: "2",
          startHour: "14:00",
          Comments:
            "אורי עם  אחד הברלינגו להביא כלב. חוזר עד 17:00 לדבר איתי על בעיות",
          driverName: "אורי",
          finishHour: "17:00",
        },
        {
          id: "126",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "4",
          TypeOfDrive: "2",
          startHour: "08:45",
          Comments: "שירי צמוד לעכו ועפולה עד 15:15. אם בעייתי דברו איתי",
          driverName: "שירי אליאס",
          finishHour: "17:00",
        },
        {
          id: "130",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "10",
          TypeOfDrive: "3",
          startHour: "14:00",
          Comments: "14:00 אייל מאשבל ליובלים ",
          driverName: "אייל יסוד",
          finishHour: "14:00,14:00",
        },
      ],
      assignedOrders: [
        {
          id: "100",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "3",
          startHour: "07:20",
          Comments:
            "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
          driverName: "רייצ'ל",
          finishHour: "10,10",
        },
        {
          id: "101",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "12:50",
          Comments: "רייצ'ל למרפאה במשגב עד 13:00",
          driverName: "רייצ'ל",
          finishHour: "14:00",
        },
        {
          id: "102",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "3",
          startHour: "19:00",
          Comments: "",
          driverName: "רייצ'ל",
          finishHour: "",
        },
        {
          id: "104",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "09:45",
          Comments: "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
          driverName: "ורד",
          finishHour: "11:00",
        },
        {
          id: "106",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "2",
          TypeOfDrive: "2",
          startHour: "15:50",
          Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
          driverName: "אלון דרור",
          finishHour: "17:20",
        },
        {
          id: "108",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "2",
          startHour: "13:30",
          Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
          driverName: "ענבר",
          finishHour: "15:30",
        },
        {
          id: "109",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "2",
          TypeOfDrive: "2",
          startHour: "16:00",
          Comments: "רז מרקפת ",
          driverName: "ענבר",
          finishHour: "16:30",
        },
        {
          id: "110",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "08:40",
          Comments:
            "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
          driverName: "ענבר",
          finishHour: "10:30",
        },
        {
          id: "115",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "16:00",
          Comments:
            "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
          driverName: "עדי",
          finishHour: "17:30",
        },
        {
          id: "116",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "13",
          TypeOfDrive: "3",
          startHour: "08:30",
          Comments: "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
          driverName: "רינת שרון",
          finishHour: "10,10",
        },
        {
          id: "117",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "9",
          TypeOfDrive: "3",
          startHour: "09:15",
          Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
          driverName: "אוריאל",
          finishHour: "12:00",
        },
        {
          id: "119",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "3",
          startHour: "07:20",
          Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
          driverName: "מורן",
          finishHour: "",
        },
        {
          id: "120",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "4",
          startHour: "14:00",
          Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
          driverName: "מורן",
          finishHour: "13:00,13:00",
        },
        {
          id: "122",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "3",
          startHour: "18:30",
          Comments:
            "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
          driverName: "תמה",
          finishHour: "22:00,22:00",
        },
        {
          id: "123",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "06:15",
          Comments: "ב615  ליאור למשגב עד 815",
          driverName: "ליאור דינרמן",
          finishHour: "08:30",
        },
        {
          id: "124",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "14",
          TypeOfDrive: "2",
          startHour: "19:15",
          Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
          driverName: "ליאור דינרמן",
          finishHour: "22:30",
        },
        {
          id: "127",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "5",
          TypeOfDrive: "3",
          startHour: "07:30",
          Comments: "עומר לתיכון ",
          driverName: "עומר כהן",
          finishHour: "",
        },
        {
          id: "128",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "5",
          TypeOfDrive: "4",
          startHour: "17:30",
          Comments:
            "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
          driverName: "עומר כהן",
          finishHour: "",
        },
        {
          id: "129",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "2",
          TypeOfDrive: "2",
          startHour: "09:00",
          Comments: "עמיר צמוד עד 15 לאזור טבריה",
          driverName: "עמיר",
          finishHour: "15:00",
        },
        {
          id: "131",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "10",
          TypeOfDrive: "4",
          startHour: "16:30",
          Comments:
            "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
          driverName: "אייל יסוד",
          finishHour: "20:00,20:00",
        },
      ],
    },
    {
      id: "2",
      name: "שנייה",
      vehicleSchedules: [
        {
          id: "2",
          VehicleId: "1",
          drives: [
            {
              id: "6",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "06:15",
              Comments: "ב615  ליאור למשגב עד 815",
              driverName: "ליאור דינרמן",
              finishHour: "08:30",
              implementsOrders: ["123"],
              description: "ליאור דינרמן במשגב",
            },
            {
              id: "7",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "08:40",
              Comments:
                "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
              driverName: "ענבר",
              finishHour: "10:30",
              implementsOrders: ["110"],
              description: "ענבר במשגב",
            },
            {
              id: "8",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "12:50",
              Comments: "רייצ'ל למרפאה במשגב עד 13:00",
              driverName: "רייצ'ל",
              finishHour: "14:00",
              implementsOrders: ["101"],
              description: "רייצ'ל במשגב",
            },
            {
              id: "9",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "15:50",
              Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
              driverName: "אלון דרור",
              finishHour: "17:20",
              implementsOrders: ["106"],
              description: "אלון דרור ברקפת",
            },
            {
              id: "10",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "18:30",
              Comments:
                "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
              driverName: "תמה",
              finishHour: "19:30",
              implementsOrders: ["122"],
              description: "תמה  אל  כרמיאל",
            },
          ],
          Comments: "",
        },
        {
          id: "3",
          VehicleId: "3",
          drives: [
            {
              id: "11",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "3",
              startHour: "07:20",
              Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
              driverName: "מורן",
              finishHour: "09:00",
              implementsOrders: ["119"],
              description: "מורן  אל  חיפה",
            },
            {
              id: "12",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "09:00",
              Comments: "עמיר צמוד עד 15 לאזור טבריה",
              driverName: "עמיר",
              finishHour: "15:00",
              implementsOrders: ["129"],
              description: "עמיר ברקפת",
            },
            {
              id: "13",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "10",
              TypeOfDrive: "4",
              startHour: "16:00",
              Comments:
                "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
              driverName: "אייל יסוד",
              finishHour: "17:00",
              implementsOrders: ["131"],
              description: "אייל יסוד מיובלים",
            },
            {
              id: "14",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "3",
              startHour: "19:00",
              Comments: "",
              driverName: "רייצ'ל",
              finishHour: "20:00",
              implementsOrders: ["102"],
              description: "רייצ'ל  אל  משגב",
            },
          ],
          Comments: "",
        },
        {
          id: "4",
          VehicleId: "4",
          drives: [
            {
              id: "15",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "3",
              startHour: "07:20",
              Comments:
                "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
              driverName: "רייצ'ל",
              finishHour: "08:20",
              implementsOrders: ["100"],
              description: "רייצ'ל  אל  כרמיאל",
            },
            {
              id: "16",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "13",
              TypeOfDrive: "3",
              startHour: "08:30",
              Comments: "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
              driverName: "רינת שרון",
              finishHour: "09:20",
              implementsOrders: ["116"],
              description: "רינת שרון  אל  רכבת כרמיאל",
            },
            {
              id: "17",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "09:45",
              Comments:
                "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
              driverName: "ורד",
              finishHour: "11:00",
              implementsOrders: ["104"],
              description: "ורד במשגב",
            },
            {
              id: "18",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "3",
              TypeOfDrive: "4",
              startHour: "13:10",
              Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
              driverName: "מורן",
              finishHour: "14:50",
              implementsOrders: ["120"],
              description: "מורן מחיפה",
            },
            {
              id: "19",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "6",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments:
                "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
              driverName: "עדי",
              finishHour: "17:30",
              implementsOrders: ["115"],
              description: "עדי במשגב",
            },
            {
              id: "20",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "14",
              TypeOfDrive: "2",
              startHour: "19:15",
              Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
              driverName: "ליאור דינרמן",
              finishHour: "22:30",
              implementsOrders: ["124"],
              description: "ליאור דינרמן באחר",
            },
          ],
          Comments: "",
        },
        {
          id: "5",
          VehicleId: "5",
          drives: [
            {
              id: "21",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "5",
              TypeOfDrive: "3",
              startHour: "07:30",
              Comments: "עומר לתיכון ",
              driverName: "עומר כהן",
              finishHour: "09:10",
              implementsOrders: ["127"],
              description: "עומר כהן  אל  חברתי",
            },
            {
              id: "22",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "9",
              TypeOfDrive: "3",
              startHour: "09:15",
              Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
              driverName: "אוריאל",
              finishHour: "10:15",
              implementsOrders: ["117"],
              description: "אוריאל  אל  מרכז",
            },
            {
              id: "23",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "1",
              TypeOfDrive: "2",
              startHour: "13:30",
              Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
              driverName: "ענבר",
              finishHour: "15:30",
              implementsOrders: ["108"],
              description: "ענבר בכרמיאל",
            },
            {
              id: "24",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "2",
              TypeOfDrive: "2",
              startHour: "16:00",
              Comments: "רז מרקפת ",
              driverName: "ענבר",
              finishHour: "16:30",
              implementsOrders: ["109"],
              description: "ענבר ברקפת",
            },
            {
              id: "25",
              flexibility: ["-30", "10"],
              passengers: "1",
              location: "5",
              TypeOfDrive: "4",
              startHour: "16:40",
              Comments:
                "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
              driverName: "עומר כהן",
              finishHour: "18:20",
              implementsOrders: ["128"],
              description: "עומר כהן מחברתי",
            },
          ],
          Comments: "",
        },
      ],
      Comments: "",
      unassignedOrders: [
        {
          id: "99",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "08:00",
          Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
          driverName: "חן פלג",
          finishHour: "13:00",
        },
        {
          id: "132",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "08:00",
          Comments: "פלג לרקפת  עד 10fsdfsdfsdfsdfsdfsdfsdfsdf",
          driverName: "חן פלג",
          finishHour: "13:00",
        },
        {
          id: "103",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "2",
          startHour: "08:30",
          Comments: "סתו מבקשת צמוד עד 16:00. לדבר איתי  אם בעיה",
          driverName: "סתו",
          finishHour: "14:00",
        },
        {
          id: "105",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "",
          TypeOfDrive: "2",
          startHour: "13:30",
          Comments: "אלון לאיסוף שיבולי השמש עד 14:30",
          driverName: "אלון דרור",
          finishHour: "14:30",
        },
        {
          id: "107",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "16:00",
          Comments: "אלון ושקד מקופח כללית משגב אם אין צמוד",
          driverName: "אלון דרור",
          finishHour: "17:00",
        },
        {
          id: "111",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "3",
          startHour: "08:15",
          Comments: "זהר לכרמיאל",
          driverName: "זהר",
          finishHour: "",
        },
        {
          id: "112",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "2",
          startHour: "14:00",
          Comments:
            "זהר בחיפה ורוצה להישאר עד מאוחר  ולחזור ברכב. אם יש נסיעה לעשות איתה חילוף מה טוב. אם לא ואפשר לשריין רכב ואנסה למצוא נהג/ת, גם טוב. ",
          driverName: "זהר",
          finishHour: "20:00",
        },
        {
          id: "113",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "",
          TypeOfDrive: "2",
          startHour: "14:00",
          Comments: "אורי כהן וטל לכנרת עד 19",
          driverName: "טל",
          finishHour: "19:00",
        },
        {
          id: "118",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "9",
          TypeOfDrive: "4",
          startHour: "14:15",
          Comments:
            "אוריאל ברכב דבר ממרכז השיח בחיפה לאשבל. אם עדיף שאני אסע ברכב אחר וישאיר את רכב דבר בחיפה אז אין בעיה. הוא יכול לשמש את הסידור אחהצ וצריך להגיע ברביעי בבוקר לטבריה או רביד ",
          driverName: "אוריאל",
          finishHour: "",
        },
        {
          id: "125",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "4",
          TypeOfDrive: "2",
          startHour: "14:00",
          Comments:
            "אורי עם  אחד הברלינגו להביא כלב. חוזר עד 17:00 לדבר איתי על בעיות",
          driverName: "אורי",
          finishHour: "17:00",
        },
        {
          id: "126",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "4",
          TypeOfDrive: "2",
          startHour: "08:45",
          Comments: "שירי צמוד לעכו ועפולה עד 15:15. אם בעייתי דברו איתי",
          driverName: "שירי אליאס",
          finishHour: "17:00",
        },
        {
          id: "130",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "10",
          TypeOfDrive: "3",
          startHour: "14:00",
          Comments: "14:00 אייל מאשבל ליובלים ",
          driverName: "אייל יסוד",
          finishHour: "14:00,14:00",
        },
      ],
      assignedOrders: [
        {
          id: "100",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "3",
          startHour: "07:20",
          Comments:
            "רייצ'ל לוקחת את ילדי גן דרור לכרמיאל, רוצה להמשיך לתור לרופאה עד 10. ",
          driverName: "רייצ'ל",
          finishHour: "10,10",
        },
        {
          id: "101",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "12:50",
          Comments: "רייצ'ל למרפאה במשגב עד 13:00",
          driverName: "רייצ'ל",
          finishHour: "14:00",
        },
        {
          id: "102",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "3",
          startHour: "19:00",
          Comments: "",
          driverName: "רייצ'ל",
          finishHour: "",
        },
        {
          id: "104",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "09:45",
          Comments: "ורד תשמח לשעה במשגב, גמישה עד 1320. לא דחוף, רק אם מסתדר.",
          driverName: "ורד",
          finishHour: "11:00",
        },
        {
          id: "106",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "2",
          TypeOfDrive: "2",
          startHour: "15:50",
          Comments: "אלון לרקפת - יעזור מאוד צמוד עד 17:20",
          driverName: "אלון דרור",
          finishHour: "17:20",
        },
        {
          id: "108",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "2",
          startHour: "13:30",
          Comments: "ענבר לכרמיאל צמוד עד 15 וחצי ",
          driverName: "ענבר",
          finishHour: "15:30",
        },
        {
          id: "109",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "2",
          TypeOfDrive: "2",
          startHour: "16:00",
          Comments: "רז מרקפת ",
          driverName: "ענבר",
          finishHour: "16:30",
        },
        {
          id: "110",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "08:40",
          Comments:
            "ענבר למשגב צמוד עד 10:10 (לא להצמיד בבקשה נסיעות כי יש סיכוי שמתבטל מחר בבוקר ",
          driverName: "ענבר",
          finishHour: "10:30",
        },
        {
          id: "115",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "16:00",
          Comments:
            "עדי יונתן ועמרי לחיסון שפעת במשגב, צמוד עד 17:30 אם אפשר עד אחרי, עדיף עד 19 ואז נעשה עוד משהו",
          driverName: "עדי",
          finishHour: "17:30",
        },
        {
          id: "116",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "13",
          TypeOfDrive: "3",
          startHour: "08:30",
          Comments: "רינת שרון לרכבת כרמיאל / לחיפה (להיות ב-10 בבת גלים) ",
          driverName: "רינת שרון",
          finishHour: "10,10",
        },
        {
          id: "117",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "9",
          TypeOfDrive: "3",
          startHour: "09:15",
          Comments: "אוריאל מאשבל למרכז השיח בחיפה ",
          driverName: "אוריאל",
          finishHour: "12:00",
        },
        {
          id: "119",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "3",
          startHour: "07:20",
          Comments: "יהל לרקפת, מורן לצומת או אם יש נסיעה לחיפה.",
          driverName: "מורן",
          finishHour: "",
        },
        {
          id: "120",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "3",
          TypeOfDrive: "4",
          startHour: "14:00",
          Comments: "מורן מהצומת, או אם יש סביב 13:00 נסיעה מחיפה",
          driverName: "מורן",
          finishHour: "13:00,13:00",
        },
        {
          id: "122",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "1",
          TypeOfDrive: "3",
          startHour: "18:30",
          Comments:
            "תמה ואמיר שוורץ לכרמיאל עד 22:00. יש סיכוי שיהיה רכב מסידור החלוץ",
          driverName: "תמה",
          finishHour: "22:00,22:00",
        },
        {
          id: "123",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "6",
          TypeOfDrive: "2",
          startHour: "06:15",
          Comments: "ב615  ליאור למשגב עד 815",
          driverName: "ליאור דינרמן",
          finishHour: "08:30",
        },
        {
          id: "124",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "14",
          TypeOfDrive: "2",
          startHour: "19:15",
          Comments: "ב1915  ליאור לרביד , סביב 2130 ליאור מרביד ",
          driverName: "ליאור דינרמן",
          finishHour: "22:30",
        },
        {
          id: "127",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "5",
          TypeOfDrive: "3",
          startHour: "07:30",
          Comments: "עומר לתיכון ",
          driverName: "עומר כהן",
          finishHour: "",
        },
        {
          id: "128",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "5",
          TypeOfDrive: "4",
          startHour: "17:30",
          Comments:
            "עומר רכב מהתיכון לאסוף את נועם וארי מקורות יש גם אופציות נוספות להיות איתי בקשר",
          driverName: "עומר כהן",
          finishHour: "",
        },
        {
          id: "129",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "2",
          TypeOfDrive: "2",
          startHour: "09:00",
          Comments: "עמיר צמוד עד 15 לאזור טבריה",
          driverName: "עמיר",
          finishHour: "15:00",
        },
        {
          id: "131",
          flexibility: ["-30", "10"],
          passengers: "1",
          location: "10",
          TypeOfDrive: "4",
          startHour: "16:30",
          Comments:
            "16:30 אייל מיובלים וממשיך עם הרכב ליובלים ועצמון, עד הלילה גמיש בשעת איסוף, צריך לצאת מיובלים ב20:00 לעצמון. יכול להקפיץ חזרה לאשבל וכו'",
          driverName: "אייל יסוד",
          finishHour: "20:00,20:00",
        },
      ],
    },
  ],
  displaySetting: {
    view: "orders",
  },
  SketchIdInEdit: null,
  pendingOrderIdInEdit: null,
  currentSessionState: {
    LocationGroupTabOpen: null,
    SketchIdInEdit: null,
    locationGroupInEdit: null,
    orderIdInEdit: null,
    pendingOrderIdInEdit: null,
    dataHolderForCurrentOrderInEdit: null,
    isAnimationRunning: true,
  },
  LocationGroups: [],
};
